<template>
  <div>
    <b-field :label="label" />
    <b-field>
      <b-input v-model="href" expanded readonly />
      <p class="control">
        <b-tooltip type="is-primary" position="is-left" :label="$t('copy')">
          <b-button :loading="isLoading" icon-left="checkbox-multiple-blank-outline" @click="copyLink" />
        </b-tooltip>
      </p>
      <p class="control">
        <b-tooltip type="is-primary" position="is-left" :label="$t('goToLink')">
          <b-button icon-left="arrow-right" @click="clickUrl" />
        </b-tooltip>
      </p>
    </b-field>
    <input ref="copyText" type="hidden" :value="href" />
  </div>
</template>

<script>
export default {
  name: "CopyLink",
  props: {
    label: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async clickUrl() {
      window.open(this.href);
    },
    copyLink() {
      try {
        this.$refs.copyText.setAttribute("type", "text");
        this.$refs.copyText.select();
        document.execCommand("copy");
        this.$buefy.toast.open({
          message: this.$t("copied"),
          type: "is-success",
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t("notCopied"),
          type: "is-danger",
        });
      }
      this.$refs.copyText.setAttribute("type", "hidden");
    },
  },
};
</script>

<style></style>
